import Modal from '@src/common/ModalPopup';
import { saveInsurance } from '@store/slices/insurance';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

export default function MMVModal(props: any) {
    let { show, handleClose, type, categoryId, setType, setFieldItemValue,setEngineCapacity } = props
    const [options, setOptions] = useState([])
    const [originalList, setOriginalList] = useState([])
    const [value, setValue] = useState<any>(null)
    const [showOtherPopup, setShowOtherPopup] = useState(false)
    const [activeModalName, setActiveModalName] = useState(props.type)
    const [otherInputFields, setOtherInputFields] = useState<any>({})
    const [otherErrorFields, setOtherErrorFields] = useState<any>({})
    const [otherPopupFields, setShowOtherPopupFields] = useState([])

    const commonState = useSelector((state: any) => state.common)
    const insuranceState = useSelector((state: any) => state.insurance)

    const dispatch: any = useDispatch()

    const handleSearch = (searchKeyword: string) => {
        let updatedList = options?.filter((e: any) => e?.label?.toLowerCase()?.includes(searchKeyword?.toLowerCase()))
        setOptions(updatedList)
        setValue(searchKeyword)

        if (!searchKeyword) {
            setOptions(originalList)
        }
    }

    const handleSelection = (element: any) => {
        let params: any = { ...insuranceState?.createInsurance }
        if(type === "version"){
            setEngineCapacity(element);
        }
        if (element?.label?.toLowerCase() === 'other') {
            setShowOtherPopup(true)
            handleClose()
            return
        }

        //reset mmv
        let resetKeys = (type === 'make') ? ['model', 'version'] : (type === 'model' ? ['version'] : [])
        for (let key of resetKeys) {
            delete params[key]
            delete params[key + '_name']
        }

        if (type === 'model') {
                delete params["parent_model_id"];
                delete params["parent_model_name"];
            
        }
        let mmvParams={ ...params, [type]: element.value, [type + '_name']: element.label };
        
        if (type === 'model') {
            mmvParams.parent_model_id=element.parentModelId;
            mmvParams.parent_model_name=element.label;
        }
        setValue(element.label)
        dispatch(saveInsurance(mmvParams))

        const { make_name, model_name } = insuranceState?.createInsurance
        const mmv = type === 'make' ? element.label : (type === 'model' ? make_name + " " + element.label : make_name + " " + model_name + " " + element.label)
        setFieldItemValue(mmv)

        let newType = (type === 'make') ? 'model' : (type === 'model' ? 'version' : null)

        if (!newType) {
            handleClose()
            setType('make')
            return
        }
        setType(newType)
        props.fetchMMV(newType,(type === 'model')?element.parentModelId:element.value)
    }

    const handleOtherPopupChange = (field: any, value: any) => {
        setOtherInputFields((prev: any) => ({ ...prev, [field]: 0, [field + "_name"]: value }))
    }

    const validateOtherInputFields = () => {
        let isError = false
        let errors: any = {}
        let keysToCheck = otherPopupFields

        for (let key of keysToCheck) {
            let updatedKey = key + "_name"
            if (!(otherInputFields?.[updatedKey])) {
                isError = true
                errors[updatedKey] = `This field is required`
            }
        }

        setOtherErrorFields(errors)
        return isError
    }

    const handleOtherModalSaveClick = () => {
        let checkError = validateOtherInputFields()
        if (checkError) return

        dispatch(saveInsurance({ ...insuranceState?.createInsurance, ...otherInputFields }))
        const { make_name, model_name, version_name } = otherInputFields;
        const mmv = [
            make_name || insuranceState?.createInsurance?.make_name, 
            model_name || insuranceState?.createInsurance?.model_name, 
            version_name || insuranceState?.createInsurance?.version_name
        ].filter(Boolean).join(" ");
        setFieldItemValue(mmv)
        setShowOtherPopup(false)
        setType('make')
        setOtherInputFields({});
    }

    useEffect(() => {
        let mmv = commonState?.mmvList?.[categoryId]
        if (mmv && Object.keys(mmv)?.length) {
            let subType = (type === 'model') ? 'make' : 'model'
            let options = mmv[type]

            if (['model', 'version'].includes(type)) {
                options = options?.filter((e: any) => (e?.[subType] === insuranceState?.createInsurance?.[subType] || e.value === 0))
            }

            setOptions(options)
            setOriginalList(options)
        }
        //eslint-disable-next-line
    }, [commonState?.mmvList, categoryId, type])

    useEffect(() => {
        let key = type + "_name"
        setValue(insuranceState?.createInsurance[key] || '')

        let currentModal = (props.type === 'make') ? 'Make' : (props?.type === 'model' ? 'Model' : "Version")
        setActiveModalName(currentModal)

        let keys = ['make', 'model', 'version']
        let inputFields: any = {}
        for (let key of keys) {
            if (insuranceState?.createInsurance[key] === 0) {
                inputFields[key + "_name"] = insuranceState?.createInsurance[key + "_name"]
            }
        }
        setOtherInputFields(inputFields)

        //eslint-disable-next-line
    }, [insuranceState?.createInsurance, type])

    useEffect(() => {
        if (showOtherPopup) {
            let fieldsToShow: any = (type === 'make') ? ['make', 'model', 'version'] : (type === 'model' ? ['model', 'version'] : ['version'])
            setOtherInputFields((prev: Record<string, string | number>) => {
                let resetFields = fieldsToShow.reduce((acc: Record<string, string | number>, field: string) => {
                    acc[field] = "";
                    acc[field + "_name"] = "";
                    return acc;
                }, { ...prev });
    
                return resetFields;
            });
            setShowOtherPopupFields(fieldsToShow)
        }
        //eslint-disable-next-line
    }, [showOtherPopup, type])

    return (
        <>
            <div className="mmv-modal add-insurnce-search-popup">
                <Modal show={show} handleClose={() => {
                    handleClose()
                    setType('make')
                }} >
                    <div className="modal-header m-sm-b">
                        <h2>Select {activeModalName}</h2>
                    </div>
                    <div className='modal-body'>
                        <div className="add-insurnace-search-outer">
                            <div className="search-bx">
                                <div className="material">
                                    <input type="text" placeholder=" " name="search_text" className="form-input" title="Search Text" aria-label="Search text" value={value} onChange={(e) => handleSearch(e.target.value)} />
                                    <i className="ic-search"></i>
                                    <label data-label={`Search ${activeModalName}`} className="form-label search-label"></label>
                                </div>
                            </div>
                            {
                                show && options?.length
                                    ?
                                    <div className="searhc-list-outer">
                                        <ul>
                                            {
                                                options?.map((element: any, idx: number) => {
                                                    return (
                                                        <li key={idx + "_" + element.value} onClick={() => handleSelection(element)}>
                                                            <label>{element.label}</label>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                    : undefined
                            }


                        </div>
                    </div>

                </Modal >
            </div >
            <div className='other-mmv-modal'>
                <Modal show={showOtherPopup} handleClose={() => {
                    setShowOtherPopup(false)
                    setOtherErrorFields({})
                    setType('make')
                }}>
                    <div className="modal-header m-b-20">
                        <h2>Select MMV</h2>
                    </div>
                    {
                        otherPopupFields?.map((item: string, idx: any) => {
                            let nameKey = item + "_name"
                            let placeholder = item?.[0] + item.substring(1, item.length)

                            return (
                                <fieldset className={'col-md-12'} key={item + "_" + idx}>
                                    <div className="material">
                                        <input
                                            maxLength={30}
                                            disabled={false}
                                            type={'text'}
                                            placeholder=" "
                                            name={item}
                                            className="form-input"
                                            value={otherInputFields?.[nameKey]}
                                            onChange={(event) => { handleOtherPopupChange(item, event.target.value) }}
                                        />
                                        <label data-label={placeholder} className="form-label"></label>
                                        {otherErrorFields?.[nameKey] ? <span className="error-txt">{otherErrorFields?.[nameKey]}</span> : null}

                                    </div>
                                </fieldset>
                            )
                        })
                    }
                    <div className="col-md-12">
                        <button className="btn-primary " onClick={() => { handleOtherModalSaveClick() }}>Save</button>
                    </div>

                </Modal>
            </div>

        </>
    )
}